var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditorBlockquote = function SvgEditorBlockquote(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.318 5 .938 1.323A12.9 12.9 0 0 0 8.166 9.4a5.54 5.54 0 0 0-.999 3.079v.337q.36-.048.66-.084.282-.035.566-.037a2.87 2.87 0 0 1 2.117.843 2.84 2.84 0 0 1 .843 2.093 3.37 3.37 0 0 1-.89 2.453A3.14 3.14 0 0 1 8.105 19a3.4 3.4 0 0 1-2.73-1.276 4.9 4.9 0 0 1-1.07-3.271A9.37 9.37 0 0 1 5.82 9.329 14.8 14.8 0 0 1 10.318 5m8.392 0 .937 1.323a12.9 12.9 0 0 0-3.09 3.078 5.54 5.54 0 0 0-.999 3.079v.337q.337-.048.638-.084a5 5 0 0 1 .59-.037 2.8 2.8 0 0 1 2.104.83 2.9 2.9 0 0 1 .805 2.106c.046.9-.265 1.78-.865 2.453a3.06 3.06 0 0 1-2.333.915 3.48 3.48 0 0 1-2.755-1.276 4.85 4.85 0 0 1-1.095-3.271c.006-1.8.537-3.56 1.528-5.063A15.3 15.3 0 0 1 18.71 5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditorBlockquote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/editor_blockquote.424cac0948399768f15963ea635831ae.svg";